import { EEventMessageType } from './event';

export enum EChartSeries {
  LINE = 'line',
  LINE_ASK = 'lineAsk',
  CANDLESTICK = 'candlestick'
}

export enum EChartLineSeriesDataType {
  ASK,
  BID
}

export interface IPostEventSeriesMessage {
  type: typeof EEventMessageType.SERIES;
  data: EChartSeries;
}
